import React, { useEffect, useState } from 'react';
import "./Bookmarks.css";

export const Bookmarks = (props) => {

  const [config, setConfig] = useState({})
  const [addBoxId, setAddBoxId] = useState(18)
  const [linkLabel, setLinkLabel] = useState("")
  const [linkURL, setLinkURL] = useState("")


  useEffect(() => {
    load(); // initial load
  }, []);

  const showEditLink = (boxid, linkid) => {
    if (linkid === -1) {
      setLinkLabel("")
      setLinkURL("")
    }
    else {
      // set to existing link details
    }
    setAddBoxId(boxid)
  }

  const addLink = () => {
    setAddBoxId(-1); // close 
  }

  const load = () => {
    // load from session state for now. Will replace with call to API 
    var newConfig = {}
    var strConfig = localStorage.getItem("bookmarks")
    if (!strConfig) {
      // data block not found, create
      newConfig = {
        lastBoxNum: 1,
        boxes: []
      }
      localStorage.setItem("bookmarks", JSON.stringify(newConfig))
    }
    else {
      newConfig = JSON.parse(strConfig)
    }
    setConfig(newConfig)
  }

  const confirmDelete = () => {

  }

  // short circuit if we don't have 
  if (!config || !config.boxes) return <div>No bookmarks</div>

  const boxContent = (box) => {
    return box.links.map(l => {
      return <div key={l.linkid } >
        <div className="row" style={{ whiteSpace: 'nowrap', display: 'inline' }}>
          <i className="fa-solid fa-trash-can deleteLinkIcon" style={{ visibility: 'hidden' }} />
          <a href={l.link}>{l.label}</a>          
        </div>
      </div>;
    })
  }

  let X = 0; 
  let Y = 100;
  const boxes = config.boxes.map((b) => {
    let tX = X; 
    let tY = Y; 
    Y += 140 + (b.links.length * 30);
    if (Y > 600) { X += 340; Y = 100; }

    return <div key={b.boxid} className="floatingBox" style={{ left: tX, top: tY, userSelect: false }}>
      <div className="card">
        <div className="card-header">
          <div className="card-title d-flex flex-nowrap">
            <i className="fa-solid fa-plus" onClick={() => showEditLink(b.boxid, -1)}></i>
            <input className="boxHeader" type="text" defaultValue={b.title} />
            <span className="float-end" onClick={confirmDelete}><i className="fa-solid fa-circle-xmark"></i></span>    
          </div>          
        </div>

        <div className="card-body boxContent">
          {b.boxid === addBoxId ?
            <>
              <div className="d-flex flex-nowrap">
                Label:<input value={linkLabel} onChange={(e)=> setLinkLabel(e.value)} /><br />
              </div>
              <div className="d-flex flex-nowrap">
                URL:<input value={linkURL} onChange={(e) => setLinkURL(e.value)} />
              </div>
              <button className="btn btn-secondary btn-small" onClick={() => setAddBoxId(-1)}>Cancel</button>
              <button className="btn btn-primary btn-small" onClick={() => addLink() } >Save</button>
            </>
            : boxContent(b)
          }
            
        </div>

        <div className="card-footer">
        </div>
        
      </div>
    </div>
  });



  const save = (newConfig) => {
    // save to session state for now. Will replace with call to API
    localStorage.setItem("bookmarks", JSON.stringify(newConfig))
    setConfig(newConfig)
  }

  return <>
    
    { boxes}
    
  </>

}